import React from 'react';

import { Paragraph6 } from '@src/theme';
import { bemClassName } from '@src/utils/bem';

import { StyledTagRounded } from './styles';

const b = bemClassName('tag-rounded');

const formatTagText = (tag) => (tag ? tag.replace(/-/g, ' ') : '');

const TagRounded = ({ text }) => {
  return (
    <StyledTagRounded>
      <span className={b()}>
        <Paragraph6>{formatTagText(text)}</Paragraph6>
      </span>
    </StyledTagRounded>
  );
};

export default TagRounded;
